import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    getCustomers (countryId,cityId) {
        return axios.get('/api/customers/list', { params: {countryId:countryId,cityId:cityId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    setMaxRefLimit(filter , page, pageSize,countryId,cityId,customerId,maxRefLimit) {
        return axios.get('/api/customers/change-max-ref-limit', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId,maxRefLimit:maxRefLimit,customerId:customerId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findCustomerBucketStatus(customerId) {
        return axios.get('/api/customers/customer-bucket-status', { params: {customerId:customerId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllCustomers (filter , page, pageSize,countryId,cityId) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllCustomersWithUsersCount (filter , page, pageSize,countryId,cityId) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter,page: page, pageSize: pageSize, countryId:countryId,cityId:cityId, withUsersCount:true} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getHiddenBrands(customerId) {
        return axios.get('/api/customers/hidden-brands', { params: { customerId: customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveHiddenBrands(customerId, brandIds) {
        return axios.post('/api/customers/hidden-brands', { customerId: customerId, brandIds: brandIds })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.customer.hiddenBrands'));
                return response.data
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getHiddenCarMakes(customerId) {
        return axios.get('/api/customers/hidden-carmake', { params: { customerId: customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveHiddenCarMakes(customerId, carMakeIds) {
        return axios.post('/api/customers/hidden-carmake', { customerId: customerId, carMakeIds: carMakeIds })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.customer.accessRights'));
                return response.data
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getCountCustomers(){
        return axios.get('/api/customers/count/customers')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOutstandingInfo () {
        return axios.get('/api/customers/outstandingInfo')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveFilePDF(formData,id){
        return axios.post("/api/customers/uploadPaymentConditions/"+id, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success(i18n.t('services.customer.save'));
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadPaymentConditions(fileName){
        axios({
            url:'/api/customers/getPaymentConditions',
            method: 'GET',
            params: {fileName:fileName } ,
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();
          });
    },

    getCustomerCurrency(){
        return axios.get('/api/customers/currency')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}

